'use strict';

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
},
    _warning = require('warning'),
    _warning2 = _interopRequireDefault(_warning),
    _translate = require('../i18n/translate'),
    _translate2 = _interopRequireDefault(_translate),
    _en = require('../i18n/translations/en'),
    _en2 = _interopRequireDefault(_en);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var createI18n = function createI18n() {
  var inputLocale = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : _en2.default,
      localeData = inputLocale;

  if ('object' === ('undefined' == typeof window ? 'undefined' : _typeof(window)) && window.vstuiLocaleData) {
    var vstuiVersion = '1.3.0',
        localeDataVersion = window.vstuiLocaleData.version,
        localeDataValid = localeDataVersion === vstuiVersion;
    localeData = localeDataValid ? window.vstuiLocaleData : _en2.default, 'production' === process.env.NODE_ENV ? void 0 : (0, _warning2.default)(localeDataValid, 'Warning: locale data version (' + localeDataVersion + ') does not match vstui version (' + vstuiVersion + '). Using \'en\' locale as a fallback.');
  }

  var _localeData = localeData,
      locale = _localeData.locale,
      direction = _localeData.direction,
      messages = _localeData.messages;
  return {
    direction: direction,
    locale: locale,
    t: function t(id, values) {
      return (0, _translate2.default)(id, values, messages);
    }
  };
};

exports.default = createI18n;